import { GraphQL } from "@rpi/openapi-api";
import React from "react";

type PaymentStatusConfig = Record<GraphQL.PaymentStatus, { name: string }>;

const paymentStatusConfig: PaymentStatusConfig = {
  [GraphQL.PaymentStatus.ExternallyPaid]: {
    name: "Externally Paid",
  },
  [GraphQL.PaymentStatus.Paid]: {
    name: "Paid",
  },
  [GraphQL.PaymentStatus.Unpaid]: {
    name: "Not Paid",
  },
  [GraphQL.PaymentStatus.NoPaymentStaffOrder]: {
    name: "No Payment - Staff Order",
  },
  [GraphQL.PaymentStatus.PaymentPending]: {
    name: "No Payment - Payment Pending",
  },
};

interface OrderPaymentStatusCellProps {
  status?: GraphQL.PaymentStatus | null;
}

export const OrderPaymentStatusCell: React.FC<OrderPaymentStatusCellProps> = ({ status }) => {
  if (!status) return <></>;

  const config = paymentStatusConfig[status];
  return <>{config.name}</>;
};
